'use client'

import classNames from 'classnames'
import { Icon, IconName } from '../Icon'
import { MouseEvent } from 'react'

type Props = {
  icon?: IconName
  label?: string
  onClick?: () => void
  textClassName?: string
  className?: string
}

export const RoundButton = ({
  icon,
  label,
  onClick,
  textClassName,
  className,
}: Props) => {
  const onClickWrap = (e: MouseEvent) => {
    if (onClick) {
      e.preventDefault()
      e.stopPropagation()
      onClick()
    }
  }

  return (
    <button
      className={classNames(
        'flex rounded-full gap-1 px-2.5 py-2 bg-gray-200 items-center shrink-0',
        className,
      )}
      onClick={onClickWrap}
    >
      {icon && <Icon name={icon} size={16} className={textClassName} />}
      {label && (
        <span
          className={classNames(
            'text-caption1 font-medium text-gray-900 whitespace-nowrap',
            textClassName,
          )}
        >
          {label}
        </span>
      )}
    </button>
  )
}
